import { render, staticRenderFns } from "./StockTakeSummaryDesktop.vue?vue&type=template&id=8af8d43c&scoped=true&lang=pug&"
import script from "./StockTakeSummaryDesktop.vue?vue&type=script&lang=js&"
export * from "./StockTakeSummaryDesktop.vue?vue&type=script&lang=js&"
import style0 from "./StockTakeSummaryDesktop.vue?vue&type=style&index=0&id=8af8d43c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af8d43c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VDataTable,VFooter,VIcon,VProgressCircular,VRow,VSimpleTable,VSpacer})
